export default __webpack_public_path__ + "static/media/Incorrecto.5dfa2773.png";